module.exports = __webpack_public_path__ + "static/media/takeoff.7dafeb94.png";